// extracted by mini-css-extract-plugin
module.exports = {"header":"Accordion_header__pwyrO","disabled":"Accordion_disabled__Owmzw"};